import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { HashLoader } from "react-spinners";
import CreatePost from "../../components/createPost";
import Header from "../../components/header";
import LeftHome from "../../components/home/left";
import RightHome from "../../components/home/right";
import Stories from "../../components/stories";
import Post from "../../components/post";
import ActiveLiveStreams from "../../components/ActiveLiveStreams";
import LiveStream from "../../components/LiveStream";
// import SendVerification from "../../components/home/SendVerification";
import "./style.css";

export default function Home({ setVisible, posts, loading, getAllPosts, openWithPicker }) {
  const { user } = useSelector((state) => ({ ...state }));
  const middle = useRef(null);
  const [height, setHeight] = useState();
  const [showLiveStream, setShowLiveStream] = useState(false);
  
  useEffect(() => {
    setHeight(middle.current.clientHeight);
  }, [loading, height]);
  
  const handleLiveStreamClick = () => {
    setShowLiveStream(true);
  };
  return (
    <div className="home" style={{ height: `${height + 150}px` }}>
              <Header 
          page="home" 
          getAllPosts={getAllPosts}
          showMessengerSidebar={false}
          onMessengerToggle={() => {}}
        />
      <LeftHome user={user} />
      <div className="home_middle" ref={middle}>
        <Stories />
        <ActiveLiveStreams />
        {/* {user.verified === false && <SendVerification user={user} />} */}
        <CreatePost 
          user={user} 
          setVisible={setVisible} 
          onLiveStreamClick={handleLiveStreamClick}
          getAllPosts={getAllPosts}
          openWithPicker={openWithPicker}
        />
        {loading ? (
          <div className="sekelton_loader">
            <HashLoader color="#1876f2" />
          </div>
        ) : (
          <div className="posts">
            {posts
              .filter(post => post.user)
              .map((post, i) => (
                <Post key={i} post={post} user={user} onPostDeleted={getAllPosts} />
              ))}
          </div>
        )}
      </div>
      <RightHome user={user} />
      
      {showLiveStream && (
        <LiveStream onClose={() => setShowLiveStream(false)} />
      )}
    </div>
  );
}
